import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {

    public data: any;
    public message: any;

    constructor(private instance: NgbActiveModal) { }

    public Close = function (action) {
        this.instance.close(action);
    }

    public Dismiss = function () {
        this.instance.dismiss();
    }

    public Save = function () {
        this.instance.dismiss();
    }

    public DismissAndRedirectBack() {
        this.instance.dismiss();
        if (this.data.action !== 'close') {
        }
    }
}
